import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.payment');

    var defaultCellTemplate =
        '<a class="grid-cell-link" ui-sref="app.payment.details({eid: row.entity.eid})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.$ctrl.view(row)">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';

    core.constant(
        'PAYMENT',
        Object.freeze({
            buyer_type: [
                { value: 'ALL', label: 'payment.form.buyer_type.all' },
                /** Société. */
                { value: 'BUSINESS', label: 'payment.form.buyer_type.business' },
                /** Particulier. */
                { value: 'CONSUMER', label: 'payment.form.buyer_type.consumer' },
                /** Gouvernement. */
                { value: 'GOVERNMENT', label: 'payment.form.buyer_type.government' },
            ],
            status: [
                { value: 'ALL', label: 'payment.form.buyer_type.all' },
                /** Initialisé. */
                { value: 'INITIALISED', label: 'payment.form.status.initialised' },
                /** Démarré */
                { value: 'STARTED', label: 'payment.form.status.started' },
                /** Annulé. */
                { value: 'CANCELLED', label: 'payment.form.status.cancelled' },
                /** Refusé. */
                { value: 'REFUSED', label: 'payment.form.status.refused' },
                /** Validé. */
                { value: 'VALIDATED', label: 'payment.form.status.validated' },
                /** Crédité. */
                { value: 'CREDITED', label: 'payment.form.status.credited' },
                /** Rejeté. */
                { value: 'REJECTED', label: 'payment.form.status.rejected' },
                /** Rejet en cours de qualif. */
                { value: 'REJECT_IN_QUALIF', label: 'payment.form.status.reject_in_qualif' },
            ],
            pagination: {
                defaultPageSize: 20,
                defaultPage: 0,
            },
            columnDefs: [
                {
                    name: 'eid',
                    displayName: 'payment.list.eid',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'payment.list.status',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'createdDate',
                    displayName: 'payment.list.createdDate',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    cellFilter: "date:'short'",
                },
                {
                    name: 'updatedDate',
                    displayName: 'payment.list.updatedDate',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    cellFilter: "date:'short'",
                },
                {
                    name: 'getSellerLabel()',
                    displayName: 'payment.list.seller',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    width: 300,
                },
                {
                    name: 'getTypeClientLabel()',
                    displayName: 'payment.list.buyerType',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'buyer',
                    displayName: 'payment.list.buyer',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'invoiceId',
                    displayName: 'payment.list.invoiceId',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'amount',
                    displayName: 'payment.list.amount',
                    headerCellFilter: 'translate',
                    cellTemplate:
                        `<div class="ui-grid-cell-contents ui-grid-cursor-pointer text-right"` +
                        ` ng-click="grid.appScope.$ctrl.view(row)"> {{row.entity.amount | currency: row.entity.currency}}</div>`,
                },
            ],
        })
    );
})();
